var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg161 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BEE4F8",
  d: "M8.483 5a6.48 6.48 0 0 1 5.691 3.375 9.24 9.24 0 0 0-3.264 6.3h-.532c-2.04 0-3.85.988-4.977 2.512A6.483 6.483 0 0 1 8.483 5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M30.762 26.295c0 .322-.205.599-.494.703l-.087.024-.075-.014a.8.8 0 0 1-.424-.274l.668-1.108a.75.75 0 0 1 .412.669m-3.392-13.68.095.254.414 1.172 1.228-.193q.454-.07.92-.07a5.885 5.885 0 0 1 5.885 5.884c0 3.094-2.394 5.645-5.503 5.866l2.27-3.776h-5.626l2.892-6.483h-10.13L16.92 25.546h-6.543a4.687 4.687 0 0 1-.214-9.37l.214-.005h1.907l.116-1.371a7.768 7.768 0 0 1 14.969-2.185"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FED100",
  d: "m20.95 16.77-2.892 10.273h4.987L20.252 39.51l9.775-16.258h-5.286l2.892-6.483z"
}))));
export { Svg161 as ReactComponent };